var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tags.length)?_c('ul',{staticClass:"tag-list"},_vm._l((_vm.tags),function(tag,i){return _c('li',{key:i,staticClass:"tag-default tag-pill tag-outline"},[_vm._v(_vm._s(tag))])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }